export enum FleetSegmentCalculationStatus {
  UPDATING = 'UPDATING',
  DELETING = 'DELETING',
  DELETED = 'DELETED',
  READY = 'READY',
}
